export default __webpack_public_path__ + "static/media/tasksvg.399ba961.svg";